module.exports = __webpack_public_path__ + "images/syuccho_kaitori_lp/strong_point/5@2x_65742ad80351cfdb8db7c5d97d4408fa.png";